<template>
  <div class="home">
    <div class="row">
      <div class="col-xl-4 col-md-12">
        <session-table :selected="selected"></session-table>
      </div>

      <div class="col-xl-8 col-md-12">
        <sessions-list :sessions="sessions"></sessions-list>
      </div>
    </div>

    <div :style="`display: ${isLoadingState?'block':'none'}`">
      <div class="row center">
        <div class="col-12">
          <div class="spinner-border" role="status">
            <span class="visually-hidden"></span>
          </div>
        </div>
      </div>
    </div>

    <div :style="`display: ${(isLoadingState || selected === null)?'none':'block'}`">
      <div class="row">
        <div class="col-12">
          <div class="row justify-content-center">
            <a v-on:click="pSelectionSwitch(dataRow.participantId)" v-for="(dataRow) of sessionParticipants"
               :key="dataRow.participantId">
              <card class="" style="margin-left: 3px;margin-right: 3px">
                <img :src="[THUMBNAIL_BASE_URL+dataRow.thumbnail]" alt=""
                     class="avatar " v-bind:class="[ dataRow.colorClass, dataRow.show?'':'deselected' ]"/>
                <div class="row justify-content-center" v-bind:class="[dataRow.show?'':'']">
                  <del v-if="!dataRow.show"><p>{{ dataRow.name }}</p></del>
                  <p v-else>{{ dataRow.name }}</p>
                </div>
              </card>
            </a>
          </div>
        </div>
      </div>


      <div class="row">

        <div class="col-xl-6 col-md-12">
          <card>
            <div class="row">
              <canvas id="user-emotions-chart"></canvas>
            </div>
          </card>
        </div>

        <div class="col-xl-6 col-md-12">
          <card>
            <div class="row">
              <canvas id="engagement-chart"></canvas>
            </div>
          </card>
        </div>

      </div>

      <div class="row d-flex align-items-stretch">

        <div class="col-xl-5 col-md-12">
          <card>
            <div class="row">
              <canvas id="attention-chart"></canvas>
            </div>
          </card>
        </div>

        <div class="col-xl-2 col-md-12">
          <card>
            <div class="row">
              <canvas id="speaking-chart"></canvas>
            </div>
          </card>
        </div>

        <div class="col-xl-5 col-md-12">
          <card>
            <div class="row">
              <canvas id="emotions-chart"></canvas>
            </div>
          </card>
        </div>

      </div>

    </div>


  </div>
</template>

<script>

import Chart from 'chart.js'
// eslint-disable-next-line no-unused-vars
import {ref, watch} from "vue"

import { SessionTable, SessionsList } from "@/components";
import {mainStore} from "@/system/mainStore";
import {THUMBNAIL_BASE_URL} from "@/system/config";
import {chartStore} from "@/system/chartStore";

export default {
  name: 'Charts',
  components: {
    SessionTable,
    SessionsList
  },

  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);

      return new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
    // eslint-disable-next-line no-unused-vars
    pSelectionSwitch: async function (id) {
      mainStore.switchParticipantSelection(id);
    }

  },

  data() {
    return {
      THUMBNAIL_BASE_URL,

      pieChartData: chartStore.speakingChart,

      sessions: mainStore.sessions,
      selected: mainStore.currentSession,
      isLoadingState: mainStore.sessionDataIsLoading,
      isLoadingSessions: mainStore.sessionsAreLoadings,

      sessionParticipants: mainStore.sessionParticipants,

      speakingChart: chartStore.speakingChart,
    }
  },

  async mounted() {
    try {
      let charts = {}

      // init charts
      charts.speakingChart = this.createChart('speaking-chart', chartStore.speakingChart.value);
      charts.userEmotionsChart = this.createChart('user-emotions-chart', chartStore.userEmotionsChart.value);
      charts.engagementChart = this.createChart('engagement-chart', chartStore.engagementChart.value);
      charts.attentionsChart = this.createChart('attention-chart', chartStore.attentionsChart.value);
      charts.emotionsChart = this.createChart('emotions-chart', chartStore.emotionsChart.value);

      await mainStore.init();
      await chartStore.init();

      // update charts if data will changed
      for (let key of ['speakingChart', 'userEmotionsChart', 'engagementChart', 'attentionsChart','emotionsChart']) {
        watch(chartStore[key],
            () => {
              charts[key].config.data = chartStore[key].value.data;
              charts[key].config.options = chartStore[key].value.options;
              charts[key].update();
            }
        )
      }

    } catch (e) {
      this.error = e.message;
    }
  }
}
</script>
